/**
 * Centralized enum definitions for the application
 * This file contains all shared enums to avoid duplication
 */

/**
 * Represents the type of activity within a lesson
 */
export enum ActivityType {
  START = "START",
  MIDDLE = "MIDDLE",
  CLOSING = "CLOSING",
}

/**
 * Represents the section type for activities with manipulatives
 */
export enum ActivitySectionType {
  GUIDED_DEMONSTRATION = "GUIDED_DEMONSTRATION",
  HANDS_ON = "HANDS_ON",
  GUIDED_EXPLORATION = "GUIDED_EXPLORATION",
}

/**
 * Represents the type of content block within an activity
 */
export enum BlockType {
  TEXT = "TEXT",
  TEXT_WITH_IMAGE_SMALL = "TEXT_WITH_IMAGE_SMALL",
  TEXT_WITH_IMAGE_BIG = "TEXT_WITH_IMAGE_BIG",
  IMAGE = "IMAGE",
  TEXT_WITH_RESOURCE = "TEXT_WITH_RESOURCE",
  HOMEWORK = "HOMEWORK",
  TEXT_WITH_RESOURCE_AND_IMAGE = "TEXT_WITH_RESOURCE_AND_IMAGE",
}

/**
 * Represents the type of educational resource
 */
export enum ResourceType {
  VIDEO = "VIDEO",
  SLIDES = "SLIDES",
  BOOK = "BOOK",
  AUDIO = "AUDIO",
  GAME = "GAME",
  // Legacy value: never offered in the UI anymore, kept only because
  // existing DB rows still use it until the data-cleanup phase.
  QUIZ = "QUIZ",
  DOWNLOAD = "DOWNLOAD",
  READING = "READING",
  LITERACY_WORKSHEET = "LITERACY_WORKSHEET",
  GAME_QUIZ = "GAME_QUIZ",
  DIAGNOSTIC = "DIAGNOSTIC",
}

/**
 * UI-only variant to distinguish between Kinder (PDF upload) and Primaria (block editor) readings.
 * Both map to ResourceType.READING on the backend.
 */
export type ReadingVariant = "kinder" | "primaria";

/**
 * Represents how a school's diary (bitácora escolar) is organized
 */
export enum SchoolDiaryType {
  FULL_DAY = "FULL_DAY",
  BY_SUBJECT = "BY_SUBJECT",
}
